module.exports = __webpack_public_path__ + "static/img/dia-del-nino-1.bfd5f3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/dia-del-nino-1.jpg
// module id = Bzl5
// module chunks = 1